var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	85: () => (loadStrictSingletonVersion("default", "@angular/core", false, [4,20,3,27], () => (__webpack_require__.e(7017).then(() => (() => (__webpack_require__(7017))))))),
	309: () => (loadStrictSingletonVersion("default", "rxjs", false, [4,7,8,2], () => (__webpack_require__.e(1340).then(() => (() => (__webpack_require__(1340))))))),
	6109: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [4,7,8,2], () => (__webpack_require__.e(3620).then(() => (() => (__webpack_require__(3620))))))),
	7615: () => (loadStrictSingletonVersion("default", "@angular/common", false, [4,20,3,27], () => (__webpack_require__.e(5229).then(() => (() => (__webpack_require__(7610))))))),
	959: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [4,20,3,25], () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(4456))))))),
	1315: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [4,20,3,27], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(5689))))))),
	4023: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [4,20,3,27], () => (__webpack_require__.e(2867).then(() => (() => (__webpack_require__(2867))))))),
	190: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [4,20,2,5], () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(1570))))))),
	200: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [4,20,2,5], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(4879))))))),
	1118: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [4,20,2,5], () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(3680))))))),
	1746: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", false, [4,20,2,5], () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(9975))))))),
	1806: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [4,20,2,5], () => (__webpack_require__.e(433).then(() => (() => (__webpack_require__(2814))))))),
	1998: () => (loadStrictSingletonVersion("default", "@angular/cdk/private", false, [4,20,2,5], () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(9227))))))),
	4460: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [4,20,2,5], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(7699))))))),
	7278: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [4,20,2,5], () => (__webpack_require__.e(6787).then(() => (() => (__webpack_require__(9168))))))),
	8046: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", false, [4,20,2,5], () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(8615))))))),
	8326: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [4,20,2,5], () => (__webpack_require__.e(113).then(() => (() => (__webpack_require__(2494))))))),
	9222: () => (loadStrictSingletonVersion("default", "@angular/cdk/layout", false, [4,20,2,5], () => (__webpack_require__.e(5531).then(() => (() => (__webpack_require__(7912))))))),
	8594: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", false, [4,20,2,5], () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(7989))))))),
	302: () => (loadStrictSingletonVersion("default", "@angular/cdk/dialog", false, [4,20,2,5], () => (__webpack_require__.e(1101).then(() => (() => (__webpack_require__(3482))))))),
	2850: () => (loadStrictSingletonVersion("default", "@angular/cdk/accordion", false, [4,20,2,5], () => (__webpack_require__.e(6799).then(() => (() => (__webpack_require__(9180))))))),
	9766: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", false, [4,20,2,5], () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(9539))))))),
	1811: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [4,20,3,27], () => (__webpack_require__.e(396).then(() => (() => (__webpack_require__(8015))))))),
	5380: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [4,20,3,25], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(436))))))),
	5854: () => (loadStrictSingletonVersion("default", "@angular/cdk/text-field", false, [4,20,2,5], () => (__webpack_require__.e(7559).then(() => (() => (__webpack_require__(9940))))))),
	1550: () => (loadStrictSingletonVersion("default", "@angular/cdk/stepper", false, [4,20,2,5], () => (__webpack_require__.e(6366).then(() => (() => (__webpack_require__(3985))))))),
	5214: () => (loadStrictSingletonVersion("default", "@angular/cdk/table", false, [4,20,2,5], () => (__webpack_require__.e(7817).then(() => (() => (__webpack_require__(198))))))),
	9970: () => (loadStrictSingletonVersion("default", "@angular/cdk/tree", false, [4,20,2,5], () => (__webpack_require__.e(333).then(() => (() => (__webpack_require__(2714))))))),
	1081: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [4,20,3,25], () => (__webpack_require__.e(4608).then(() => (() => (__webpack_require__(2227))))))),
	2625: () => (loadStrictSingletonVersion("default", "@fortawesome/fontawesome-svg-core", false, [4,6,7,2], () => (__webpack_require__.e(3509).then(() => (() => (__webpack_require__(3509))))))),
	525: () => (loadStrictSingletonVersion("default", "@angular/router", false, [4,20,3,25], () => (__webpack_require__.e(8420).then(() => (() => (__webpack_require__(6039)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"78": [
		85,
		309,
		1118,
		1806,
		5214,
		6109,
		8326,
		8594
	],
	"80": [
		7615
	],
	"113": [
		309,
		6109,
		7615
	],
	"198": [
		85,
		309,
		6109,
		7615
	],
	"370": [
		309
	],
	"396": [
		309,
		6109
	],
	"436": [
		85,
		1811,
		7615
	],
	"604": [
		85,
		200,
		309,
		1118,
		1746,
		1806,
		1998,
		4460,
		6109,
		7278,
		8046,
		8326,
		9222,
		9766
	],
	"681": [
		85,
		309,
		525,
		1811,
		6109,
		7615
	],
	"708": [
		85,
		200,
		309,
		959,
		1118,
		1806,
		1998,
		4460,
		6109,
		7615,
		8326,
		8594,
		9222,
		9766
	],
	"760": [
		85,
		309,
		1118,
		6109,
		8326,
		8594,
		9970
	],
	"1101": [
		7615
	],
	"1208": [
		85,
		959,
		1118,
		1806,
		1998,
		4460,
		8326,
		9222
	],
	"1423": [
		85,
		959,
		1118,
		1806,
		1998,
		4460,
		8326,
		8594,
		9222
	],
	"1570": [
		85,
		309,
		6109,
		7615
	],
	"1693": [
		85,
		309,
		1118,
		1811,
		5380,
		6109,
		8326
	],
	"2075": [
		309,
		6109,
		7615
	],
	"2152": [
		85,
		190,
		200,
		309,
		959,
		1118,
		1746,
		1806,
		1998,
		4460,
		6109,
		7278,
		7615,
		8046,
		8326,
		9222
	],
	"2227": [
		85
	],
	"2243": [
		85,
		190,
		200,
		309,
		959,
		1118,
		1746,
		1806,
		1998,
		4460,
		6109,
		7278,
		7615,
		8046,
		8326,
		8594,
		9222,
		9766
	],
	"2265": [
		85,
		200,
		309,
		1118,
		1806,
		1998,
		4460,
		6109,
		8326,
		9222
	],
	"2356": [
		7615
	],
	"2494": [
		85,
		309,
		6109,
		7615
	],
	"2545": [
		85,
		190,
		200,
		302,
		309,
		1118,
		1746,
		1806,
		6109,
		7278,
		8326,
		9222
	],
	"2569": [
		85,
		309,
		1118,
		1806,
		4460,
		6109,
		7615,
		8046,
		8326,
		9222,
		9766
	],
	"2611": [
		85,
		309,
		959,
		1118,
		1806,
		1998,
		4460,
		8326,
		9222
	],
	"2714": [
		85,
		309,
		6109
	],
	"2814": [
		85
	],
	"3482": [
		85,
		309,
		6109,
		7615
	],
	"3680": [
		85
	],
	"3973": [
		85,
		1118,
		8326,
		9222
	],
	"3985": [
		85,
		309,
		959,
		6109
	],
	"4241": [
		85,
		309,
		1118,
		1550,
		1806,
		1811,
		1998,
		4460,
		5380,
		6109,
		7278,
		7615,
		8326,
		9222
	],
	"4358": [
		85,
		190,
		200,
		309,
		959,
		1118,
		1746,
		1806,
		1998,
		4460,
		6109,
		7278,
		7615,
		8046,
		8326,
		9222
	],
	"4428": [
		85,
		200,
		309,
		1118,
		1998,
		8326,
		9222
	],
	"4456": [
		85,
		309,
		6109,
		7615
	],
	"4643": [
		85,
		959,
		1118,
		1806,
		1998,
		4460,
		8326,
		9222
	],
	"5137": [
		85,
		2625,
		5380
	],
	"5229": [
		309
	],
	"5531": [
		309,
		6109,
		7615
	],
	"5728": [
		85,
		190,
		309,
		1118,
		1806,
		1998,
		4460,
		6109,
		7278,
		8326,
		9222
	],
	"6039": [
		85,
		309,
		5380,
		6109,
		7615
	],
	"6158": [
		85,
		1118,
		8326
	],
	"6216": [
		85,
		1081,
		7615
	],
	"6366": [
		959
	],
	"6556": [
		85,
		1118,
		1806,
		1998,
		4460,
		8326,
		9222
	],
	"6743": [
		85,
		200,
		309,
		959,
		1118,
		1806,
		1998,
		4460,
		6109,
		7615,
		8046,
		8326,
		9222
	],
	"6941": [
		85,
		200,
		309,
		1118,
		1998,
		2850,
		6109,
		7278,
		8326,
		8594,
		9222
	],
	"7017": [
		309,
		1315,
		4023,
		6109
	],
	"7171": [
		85,
		1118,
		4460,
		8326
	],
	"7483": [
		85,
		200,
		959,
		1118,
		1806,
		1998,
		4460,
		8326,
		8594,
		9222
	],
	"7556": [
		85,
		190,
		200,
		309,
		959,
		1118,
		1746,
		1806,
		1998,
		4460,
		6109,
		7615,
		8046,
		8326,
		8594,
		9222,
		9766
	],
	"7610": [
		85,
		309
	],
	"7699": [
		85,
		7615
	],
	"7817": [
		7615
	],
	"7912": [
		85,
		309,
		6109,
		7615
	],
	"7922": [
		85,
		309,
		959,
		1118,
		1806,
		4460,
		5854,
		6109,
		7615,
		8046,
		8326,
		9222,
		9766
	],
	"7989": [
		85,
		309
	],
	"8015": [
		85,
		309,
		6109
	],
	"8055": [
		1811,
		7615
	],
	"8259": [
		85,
		190,
		200,
		309,
		1118,
		1746,
		1806,
		4460,
		6109,
		7278,
		7615,
		8326,
		9222
	],
	"8420": [
		5380,
		6109,
		7615
	],
	"8615": [
		85,
		309,
		6109
	],
	"8653": [
		85,
		190,
		200,
		309,
		1118,
		1746,
		1806,
		1998,
		4460,
		6109,
		7278,
		8326,
		9222
	],
	"8730": [
		85,
		1118,
		1806,
		6109,
		8326
	],
	"8753": [
		85,
		1118,
		7615,
		8326,
		9222
	],
	"9168": [
		85
	],
	"9180": [
		85,
		309
	],
	"9189": [
		7615
	],
	"9227": [
		85
	],
	"9430": [
		85,
		200,
		309,
		1118,
		1746,
		1806,
		4460,
		6109,
		8326,
		9222
	],
	"9539": [
		85,
		309,
		6109
	],
	"9804": [
		85,
		309,
		1811
	],
	"9940": [
		85,
		309,
		6109,
		7615
	],
	"9975": [
		85,
		309,
		6109,
		7615
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}